var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.2044V21.2222C23 22.2 22.28 23 21.4 23H8.6C7.72 23 7 22.2 7 21.2222V10.5556C7 9.57778 7.72 8.77778 8.6 8.77778H16.68C16.632 9.06222 16.6 9.36444 16.6 9.66667C16.6 10.9822 17.12 12.1467 17.936 12.9644L15 15L8.6 10.5556V12.3333L15 16.7778L19.24 13.8267C19.672 14.0044 20.12 14.1111 20.6 14.1111C21.504 14.1111 22.328 13.7644 23 13.2044ZM18.2 9.66667C18.2 11.1422 19.272 12.3333 20.6 12.3333C21.928 12.3333 23 11.1422 23 9.66667C23 8.19111 21.928 7 20.6 7C19.272 7 18.2 8.19111 18.2 9.66667Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotEmail);
export default __webpack_public_path__ + "static/media/dot-email.9391c1cd7f143be4b4c48a36deba60c8.svg";
export { ForwardRef as ReactComponent };